/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiProductIncludedData } from './hei-product-included.data';
import { IHeiProductIncludedProps } from './hei-product-included.props.autogenerated';

export interface IHeiProductIncludedViewProps extends IHeiProductIncludedProps<IHeiProductIncludedData> {}

/**
 *
 * HeiProductIncluded component
 * @extends {React.PureComponent<IHeiProductIncludedProps<IHeiProductIncludedData>>}
 */
class HeiProductIncluded extends React.PureComponent<IHeiProductIncludedProps<IHeiProductIncludedData>> {
    public render(): JSX.Element | null {
        const {
            data: { productInfo }
        } = this.props;

        const html = productInfo.result?.IncludedHtml;
        if (!html) {
            return null;
        }

        return this.props.renderView(this.props);
    }
}

export default HeiProductIncluded;
